import { Button } from 'components/ui/button';
import { Icon } from 'components/ui/icon';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';

export interface StoreListHeaderProps {
  storeCount: number;
  onAddStore: () => void;
}

export const StoreListHeader = ({
  storeCount,
  onAddStore,
}: StoreListHeaderProps) => {
  const storeText = storeCount === 1 ? 'store' : 'stores';

  return (
    <div className="flex items-center justify-between pb-1 md:pb-4 overflow-y-scroll overflow-x-hidden">
      <div className="flex items-center gap-2">
        <h1
          className="text-lg lg:text-2xl font-semibold leading-8 text-gray-blue-90"
          data-testid="store-list-heading"
        >
          Your linked {storeText} ({storeCount})
        </h1>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex items-center justify-center cursor-help">
                <Icon
                  name="help-circle"
                  size={18}
                  className="text-gray-blue-50 hover:text-gray-blue-70"
                />
              </span>
            </TooltipTrigger>
            <TooltipContent side="right">
              To open quick search, use ⌘+K (Mac) or Ctrl+K (Windows)
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={onAddStore}
        iconStart="plus"
        aria-label="Add a new store"
        data-testid="add-store-button"
      >
        <span className="max-md:hidden" data-testid="add-store-text">
          Add a store
        </span>
      </Button>
    </div>
  );
};
